import { SuccessNotification, ErrorNotification } from "./Notification";
import api, { BASE_URL } from "./api"
import axios from "axios"

/**
 * Resend first-time / login OTP via public endpoint.
 * POST auth/resend-otp/ { email }
 */
export const createSms = async (emailOverride) => {
  let email = emailOverride
  if (!email) {
    try {
      const user = window.localStorage.getItem("user")
      email = user ? JSON.parse(user)?.email : window.localStorage.getItem("email")
    } catch {
      email = window.localStorage.getItem("email")
    }
  }

  const normalizedEmail =
    typeof email === "string" ? email.replace(/^"|"$/g, "").trim() : ""

  if (!normalizedEmail) {
    ErrorNotification("Email is required to resend the verification code")
    return
  }

  try {
    const { data } = await axios.post(`${BASE_URL}auth/resend-otp/`, {
      email: normalizedEmail,
    })
    SuccessNotification(
      data?.message ||
        "A new verification code was sent. Use the latest code from your email or SMS."
    )
    return data
  } catch (error) {
    ErrorNotification(
      error?.response?.data?.error ||
        error?.response?.data?.message ||
        "There was an error resending the verification code"
    )
    throw error
  }
};

/** Legacy alias — prefer createSms / auth/resend-otp for account verification. */
export const sendOtpLegacy = async () => {
  await api.post("auth/sendotp/")
}
